module.exports = __webpack_public_path__ + "0b7434ecd0bfcce77f8ad5e16ba78bbc.svg";